import { useState } from 'react';
import { ShareIcon } from '../Icons/Icons';
import { Share as ShareLu } from 'lucide-react';
import { useTranslation } from '@/lib/i18n';
import ShareModal from '@/components/ShareModal';
import { createPortal } from 'react-dom';

export default function ShareA({
  hashId,
  showText,
  chatId,
  query,
}: {
  query: string;
  chatId: string;
  hashId?: number;
  showText?: boolean;
}) {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <button
        className="flex flex-row items-center h-8 px-2.5 gap-1.5 text-black/70 dark:text-text-tertiary text-sm rounded-[16px] hover:bg-[#E9E9E9] dark:hover:bg-[#1e1e1e] transition duration-200 hover:text-black dark:hover:text-white"
        onClick={() => setIsModalOpen(true)}
      >
        {showText ? <ShareIcon /> : <ShareLu size={17} />}
        {showText && t('Share')}
      </button>

      {isModalOpen &&
        createPortal(
          <ShareModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            chatId={chatId}
            messageIndex={hashId}
            query={query}
          />,
          document.body,
        )}
    </>
  );
}
